import { MantineColorScheme } from "@mantine/core";

const COLOR_SCHEMES = [
  "light",
  "dark",
  "auto",
] as const satisfies readonly MantineColorScheme[];

/** The color scheme saved in the user's settings, which the server doesn't validate */
export const isColorScheme = (value: unknown): value is MantineColorScheme =>
  (COLOR_SCHEMES as readonly unknown[]).includes(value);
